export const EnPowerIdType = Object.freeze({
    defaultEnPowerId: '@EnPowerAccountId',
    noEnpowerId: 'EN.Power'
});